import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "~/components/ui/page";
import { ErrorState, Skeleton } from "~/components/ui/states";
import { fetchInvoice, InvoiceBackLink, InvoicePage } from "~/features/sales/invoice-page";

export const Route = createFileRoute("/_app/invoices/$id")({ component: InvoiceRoute });

function InvoiceRoute() {
  const { id } = Route.useParams();
  const query = useQuery({ queryKey: ["invoices", id], queryFn: () => fetchInvoice(id) });
  if (query.isPending)
    return (
      <Page>
        <InvoiceBackLink />
        <Skeleton className="h-8 w-60" />
        <Skeleton className="mt-6 h-96 w-full" />
      </Page>
    );
  if (query.isError)
    return (
      <Page>
        <InvoiceBackLink />
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      </Page>
    );
  return <InvoicePage key={`${query.data.id}-${query.data.updatedAt}`} invoice={query.data} />;
}
